export const personalInfo = {
  name: "Maryam",
  title: "QA Engineer | Freelance QA Consultant | AI-Assisted Automation",
  email: "maryamkhanmadova@gmail.com",
  bio: "As a passionate Software Quality Assurance Engineer and Automation Specialist with over 2 years of experience, I drive software excellence by designing and implementing comprehensive testing strategies and scalable automation frameworks. I excel at creating robust test suites, uncovering critical issues early, and collaborating closely with development teams to deliver high-quality, reliable, and high-performing software. As a freelance QA consultant, I own quality across UI, API, integration and performance testing, turning findings into clear release risks and practical recommendations for clients.",
  location: "Remote",
  experience: "2+ years",
};

export const skills = [
  {
    category: "Testing Methodologies",
    items: [
      "Manual Testing",
      "Automation Testing",
      "API Testing",
      "Performance Testing",
      "Security Testing",
    ],
  },
  {
    category: "Tools & Frameworks",
    items: [
      "Selenium",
      "Cypress",
      "Playwright",
      "Jest",
      "Postman",
      "JIRA",
      "TestRail",
    ],
  },
  {
    category: "Programming Languages",
    items: ["C#", "JavaScript", "Java", "Python", "SQL"],
  },
  {
    category: "CI/CD & DevOps",
    items: ["Jenkins", "GitHub Actions", "Docker", "Testinium"],
  },
  {
    category: "Performance & Code Quality",
    items: ["k6 performance scenarios", "Grafana setup & monitoring", "SonarQube analysis", "Docker-based tool integration", "Quality risk reporting"],
  },
  {
    category: "AI-Assisted QA & Automation",
    items: ["ChatGPT", "Claude", "Codex", "AI-assisted test scenario ideation", "Prompting for QA workflows", "AI-assisted automation scripting", "Human review of generated test cases and code"],
  },
];

export const projects = [
  {
    id: 6,
    title: "kibcar.com",
    role: "Freelance QA Consultant — End-to-End QA Ownership",
    description: "Planned and executed end-to-end QA across UI, API, integration and performance layers, prioritizing critical user journeys, negative scenarios and high-risk edge cases.",
    highlights: [
      "Combined exploratory and regression testing with API validation and performance analysis.",
      "Documented defects with reproducible evidence and actionable technical context for the client and development team."
    ],
    technologies: ["UI Testing", "API Validation", "Integration", "Regression", "Performance"],
    website: "https://kibcar.com",
    bgColor: "mid-blue",
    category: "Freelance QA",
  },
  {
    id: 7,
    title: "Confidential Web Platform (NDA)",
    role: "Freelance QA Consultant — Pre-Production Quality Ownership",
    description: "Owned QA coverage for a large product with a real-time business flow and three dashboard workflows, designing risk-based UI, API, integration, regression and performance test coverage.",
    highlights: [
      "Built performance scenarios with k6 and independently installed and configured Grafana to monitor behavior and identify bottlenecks.",
      "Integrated SonarQube with Docker, generated code-quality reports, and presented consolidated quality risks, findings and recommendations before production release.",
      "Tested cross-flow dependencies and complex user journeys to uncover integration defects and edge cases before launch."
    ],
    technologies: ["k6", "Grafana", "SonarQube", "Docker", "Risk-Based Testing"],
    confidentiality: "Client identity, product details and test evidence are confidential under NDA.",
    bgColor: "mid-purple",
    category: "Freelance QA",
  },
  {
    id: 1,
    title: "API Test Plugin Cypress",
    description:
      "A custom API testing plugin built on top of Cypress to streamline automated API validation. The plugin simplifies request/response handling, improves test reusability through custom commands, and speeds up regression testing for scalable QA workflows.",
    technologies: ["Cypress"],
    github: "https://github.com/MaryamKhanmadova/API_plugin.git",
    bgColor: "light-yellow",
    category: "Automation Testing",
    isVisible: false,
  },
  {
    id: 2,
    title: "HR Automation Email System",
    description:
      "A full-featured web application that automates daily HR email workflows. The system supports dynamic email generation, template management, input validation, and real-time preview. Built with Node.js, React, and deployed on Vercel, it delivers a fast, modern, and reliable automation solution.",
    technologies: ["Node.js", "React", "Javascript", "Vercel"],
    liveDemo: "https://email-automation-hr.vercel.app/",
    github: "https://github.com/MaryamKhanmadova/email-automation",
    bgColor: "mid-blue",
    category: "Automation flow",
    isVisible: true,
  },
  {
    id: 3,
    title: "Hotel Backend Project API",
    description:
      "A fully functional backend API designed for hotel operations such as reservations, room management, user authentication, and administrative features. Developed using .NET Core, Entity Framework, SQL Server, and JWT authentication, the project follows clean, scalable, and production-grade RESTful architectures.",
    technologies: [
      "C#",
      "Asp .Net Core",
      "MsSql Server",
      "Entity Framework",
      "JWT",
    ],
    github: "https://github.com/MaryamKhanmadova/UdemyHotelProject.API",
    bgColor: "light-pink",
    category: "Backend Project",
    isVisible: false,
  },
  {
    id: 4,
    title: "Alpha Hotel Backend Project MVC",
    description:
      "An ASP.NET Core MVC backend application created to simplify hotel management workflows. The system includes modules for room operations, reservations, user roles, and admin features. Built with Entity Framework and SQL Server, following clean code practices and a maintainable, scalable project structure.",
    technologies: ["C#", "Asp .Net Core", "MsSql Server", "Entity Framework"],
    github: "https://github.com/MaryamKhanmadova/AlphaHotel",
    bgColor: "light-pink",
    category: "Backend Project",
    isVisible: false,
  },
  {
    id: 5,
    title: "Daily Automation Script",
    description:
      "An ASP.NET Core MVC backend application created to simplify hotel management workflows. The system includes modules for room operations, reservations, user roles, and admin features. Built with Entity Framework and SQL Server, following clean code practices and a maintainable, scalable project structure.",
    technologies: ["Node.js", "JavaScript", "MongoDB", "Html, CSS"],
    github: "https://github.com/MaryamKhanmadova/daily-automation-script.git",
    bgColor: "mid-blue",
    category: "Automation flow",
    isVisible: false,
  },
];

export const socialLinks = [
  {
    name: "GitHub",
    url: "https://github.com/MaryamKhanmadova",
    icon: "Github",
  },
  {
    name: "LinkedIn",
    url: "https://linkedin.com/in/maryamkhanmadova",
    icon: "Linkedin",
  },
  {
    name: "Email",
    url: "mailto:maryamkhanmadova@gmail.com",
    icon: "Mail",
  },
];


export const services = [
  { title: "End-to-End QA Ownership", description: "Quality coverage for a new product, a major feature or an upcoming release across UI, API and integrations.", deliverable: "Risk-based test plan, critical journey coverage and a prioritized defect report." },
  { title: "Exploratory & Regression Testing", description: "Find edge cases, negative scenarios and defects across connected workflows and dashboards.", deliverable: "Reproducible bug reports, supporting evidence and a reusable regression checklist." },
  { title: "API & Test Automation", description: "Validate API behavior and build repeatable checks for critical user journeys.", deliverable: "API validation coverage, automated checks and documented execution steps." },
  { title: "Performance Testing & Monitoring", description: "Model load with k6 and use Grafana to understand response times, errors and bottlenecks.", deliverable: "Performance scenarios, monitoring setup and an analysis of observed behavior." },
  { title: "Pre-Production Quality Review", description: "Bring functional findings, performance evidence and SonarQube code-quality analysis together before launch.", deliverable: "Consolidated release risks, quality reports and practical recommendations." },
  { title: "AI-Assisted QA Workflows", description: "Use AI to support test ideation, documentation and automation scripting, with human review of generated output.", deliverable: "Reviewed test scenarios and scripts aligned with your product requirements." },
];
